
// API Root Endpoint
// DEV
// const api = 'http://localhost:8080/'
// PROD
 const api = 'http://192.81.129.36:8080/'

 export default api




// WEBPACK FOOTER //
// ./src/api/ApiConst.js